import { PropertyTypeEnum } from '@/bundles/Property/interfaces/PropertyType';
import { ISOCHRONE_COLOR } from '@/bundles/Map/helpers/isochrone/IsochroneLayerConsts';

export const PLACE_TYPE_COLORS: Record<string, string> = {
  company: '#1C5F67',
  contact: '#850A0A',
  occupier: '#73166A',
};

export const PROPERTY_TYPE_COLORS: Record<string, string> = {
  [PropertyTypeEnum.healthcare]: '#5D155C',
  [PropertyTypeEnum.industrial]: '#3172D6',
  [PropertyTypeEnum.land]: '#EC9E41',
  [PropertyTypeEnum.multiFamily]: '#54A8B5',
  [PropertyTypeEnum.office]: '#EC6756',
  [PropertyTypeEnum.retail]: '#F0CE60',
  [PropertyTypeEnum.selfStorage]: '#8962C9',
  [PropertyTypeEnum.hospitality]: '#5D9DDD',
  [PropertyTypeEnum.specialPurpose]: '#B78E55',
};

export const DEFAULT_MARKER_COLOR = '#555555';

export const IN_HOUSE_COLOR = '#97012d';

export { ISOCHRONE_COLOR };
